export const STATUS_STYLES = {
  "On Track": { badge: "bg-[#ECF8F1] text-[#1A5633] border-[#A3E2BB]", dot: "#2E8B57" },
  "At Risk": { badge: "bg-[#FFF8EC] text-[#824D0E] border-[#FCE3B5]", dot: "#C97A1B" },
  "Critical": { badge: "bg-[#FDF2F4] text-[#8A0822] border-[#F8C4CC]", dot: "#BA0C2F" },
  "Not Started": { badge: "bg-[#F1F3F6] text-[#4A525D] border-[#D2D7DF]", dot: "#98A2AF" },
};

export const TASK_STATUS_STYLES = {
  "Not Started": "bg-[#F1F3F6] text-[#4A525D] border-[#D2D7DF]",
  "In Progress": "bg-[#FBEAED] text-[#8A0822] border-[#F1B9C3]",
  "Blocked": "bg-[#FDF2F4] text-[#8A0822] border-[#F8C4CC]",
  "Ready for Review": "bg-[#FFF8EC] text-[#824D0E] border-[#FCE3B5]",
  "Completed": "bg-[#ECF8F1] text-[#1A5633] border-[#A3E2BB]",
};

export const ROLE_LABELS = {
  it_admin: "IT Admin / Superuser",
  pmo: "PMO",
  executive: "Executive Team",
  it_executive: "IT Executive",
  engineer: "IT Engineer / Analyst",
};

export const ROLE_HOME = {
  it_admin: "/admin/users",
  pmo: "/pmo",
  executive: "/dashboard",
  it_executive: "/dashboard",
  engineer: "/my-responsibility",
};

export function money(n) {
  if (n == null) return "$0";
  if (Math.abs(n) >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (Math.abs(n) >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n}`;
}
